import { isToday } from 'date-fns'
import { IdPayload, ViewItem } from '../../../types/interfaces'

export const useViewContact = () => {
  const calculate = (data: ViewItem[]) => {
    return {
      today: data.filter((el) => el.createdAt && isToday(el.createdAt)).length,
      total: data.length,
    }
  }
  return { calculate }
}
